/**
 * File: organizationMessage.new.js [mobile]
 * Author: Tyler Petresky
 *
 * Description: This file contains the controller for the
 * writing a new organization message. It renders the view
 * organizationMessage.new.html and controls all of the functionality
 * including calling the create() methods from the OrganizationMessages
 * model.
 */

'use strict';

angular.module('shiftTraderApp')
    .controller('OrganizationMessageNewCtrl', function ($http, $scope, $state, $rootScope, $confirm, $modal, flash, TimeService,
                                                        allPositions, ServerUrls, UserPermissionsService, OrganizationMessages, Session, org, Users) {

      $scope.org = org;
      $scope.isAllowedToCreate = $scope.org.$isAllowedToCreate();
      if (!$scope.isAllowedToCreate) {
        $rootScope.openNeedToPayModal();
      }

      // Sending mode flags
      $scope.state = {
        sendingToAll: true,
        currentDatepickerOpened: false,
        currentDatepickerDate: moment().add(7, 'days').toDate(),
        messageType: 'email',
        rawPermissions: null,
        q: {
          isSms: function() {
            return $scope.state.messageType === 'sms' || $scope.state.messageType === 'both';
          },
          canBuyTokens: function() {
            if ($scope.state.rawPermissions) {
              return ('token_ledgers.buy_tokens' in $scope.state.rawPermissions) ? $scope.state.rawPermissions['token_ledgers.buy_tokens'] : false;
            } else {
              return false;
            }
          },
          canSendMessage: function() {
            if ($scope.state.rawPermissions) {
              return ('organization_messages.create' in $scope.state.rawPermissions) ? $scope.state.rawPermissions['organization_messages.create'] : false;
            } else {
              return false;
            }
          }
        }
      };

      var permissionsToLookUp = [
        'organization_messages.create',
        'token_ledgers.buy_tokens'
      ];

      UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
        .then(function(dikt) {
          $scope.state.rawPermissions = dikt;

          if (!$scope.state.q.canSendMessage()) {
            $state.go('home');
          }
        });

      // Is the controller currently creating new messages?
      // Used in sendMessage().
      $scope.currentlyCreating = false;

      // Contains the data from the <textarea> input box
      // as well as the date picker. This is the message's data.
      $scope.formData = {
        expiresDate: moment().add(2, 'days').toDate(),
        content: ''
      };

      // Run an HTTP request to the server to get the current token amount.
      $scope.currentCredits = 0;
      $http.get(ServerUrls.current.railsApi + 'organizations/' + org.id + '/token_ledgers/latest')
        .then(function(response) {
          $scope.currentCredits = (response != null && response.data != null && response.data.balance != null) ? response.data.balance : 0;
        });

      // Credit multiplier is used to change how many tokens will be used
      // for sending longer messages. If a message hits more than 160 chars,
      // Stripe will split the message into multiple texts. We need to charge
      // for this occurrence.
      $scope.creditsMultiplier = 1;
      $scope.$watch('formData.content', function(newVal, oldVal) {
        if (newVal.length > 148) {
          $scope.creditsMultiplier = Math.ceil((newVal.length - 148) / 160) + 1;
        } else {
          $scope.creditsMultiplier = 1;
        }
      });

      // Get the current max number of characters before overflowing into
      // another text message.
      $scope.currentCharacterCeiling = function() {
        if ($scope.formData.content.length <= 148) {
          return 148;
        } else {
          return 148 + ($scope.creditsMultiplier - 1)  * 160;
        }
      }

      // Base settings for the datepicker input.
      $scope.datePickerOptions = {
        'starting-day': $scope.startOfWeekDay,
        'show-weeks': false
      };


      $scope.openCurrentDatepicker = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        if ($scope.state.currentDatepickerOpened === true) {
          $scope.state.currentDatepickerOpened = false;
        } else {
          $scope.state.currentDatepickerOpened = true;
        }
      };

      // Static object that contains the 'All Employees'
      // pill option for the Send-To selection.
      var allPillObject = {
        type: 'all',
        obj: {
          name: 'All Employees'
        }
      };


      // OutputData is where the objects from the autocomplete bar land.
      $scope.outputData = {};
      // Currently selected objects (positions, users, etc)
      $scope.selectedObjects = [allPillObject];
      // Currently selected user id's. This is built from selectedObjects
      // inside of convertSelectionsToUserIds().
      $scope.selectedUserIds = [];

      // All of the available choices for the autocomplete bar to search.
      $scope.autocompleteData = [allPillObject];

      // Grab all users from the organization and add them to the search data.
      getUsers();
      assembleAutocompleteData();

      // Watch the outputData object and, depending on the type of addition,
      // add the required user id's to the selectedUserIds list.
      $scope.$watch('outputData', function(newVal, oldVal) {
        if (newVal !== oldVal && _.has(newVal, 'title')) {
          // If we are currently sending to all and we
          // add a new person, we need to remove "All".
          if ($scope.state.sendingToAll) {
            $scope.selectedObjects.splice(_.findIndex($scope.selectedObjects, {type: 'all'}), 1);
            $scope.state.sendingToAll = false;
          }
          else if (!$scope.state.sendingToAll && newVal.originalObject.type == 'all') {
            $scope.state.sendingToAll = true;
          }
          $scope.selectedObjects.push(newVal.originalObject);
          convertSelectionsToUserIds();
        }
      });

      /**
       * Activated when an 'X' is clicked inside of a pill in the view.
       * This will remove the selected pill and user from the list.
       */
      $scope.removePill = function(index) {
        $scope.selectedObjects.splice(index, 1);

        convertSelectionsToUserIds();
      };

      /**
       * Assembles all of the positions and users
       * that are searchable to add into the
       * autocomplete bar.
       */
      function assembleAutocompleteData() {
        _.each(allPositions, function(pos) {
          $scope.autocompleteData.push({type:'position', obj: pos});
        });
      }

      function assembleUsersAutocompleteData() {
        _.each($scope.users, function(user) {
          $scope.autocompleteData.push({type: 'user', obj: user});
        });
        convertSelectionsToUserIds();
      }

      /**
       * Converts the currently selected objects (users
       * and positions) into user ids. The resultiung
       * array will be used to know who to send messages to.
       */
      function convertSelectionsToUserIds() {
        var positionIds = [];
        $scope.selectedUserIds = [];

        _.each($scope.selectedObjects, function(sel) {
          if (sel.type == 'all') {
            $scope.selectedUserIds = _.pluck($scope.users, 'id');
            return;
          }
          else if (sel.type == 'user') {
            $scope.selectedUserIds.push(sel.obj.id);
          } else if (sel.type == 'position') {
            positionIds.push(sel.obj.id);
          }
        });

        $scope.selectedUserIds = _.union(
          $scope.selectedUserIds,
          _.pluck(_.where($scope.users, function(user) {
            return _.any(user.users_positions, function(user_pos) {
              return _.contains(positionIds, user_pos.position_id);
            });
          }), 'id')
        );
      }

      /**
       * Retrieves all of the user data from the data model
       */
      function getUsers() {
        Users.getAll({status: 'active'})
          .then(function(users) {

            $scope.users = users;

            assembleUsersAutocompleteData();
          }, function(res) {
          });
      }

      /**
       * Open up a modal to buy more tokens.
       */
      $scope.activateBuyTokenModal = function() {
        var modalInstance = $modal.open({
          size: 'md',
          templateUrl: 'views/buyTokenPlanDialog.html',
          controller: 'BuyTokenPlanDialogCtrl',
          resolve: {
            params: function() {
              return {
                org: $scope.org
              }
            }
          }
        });
        modalInstance.result.then(function(result) {
            if (result > 0) {
              $scope.currentCredits = result;
            }
          });
      };

      /**
       * Use the data collected from the view to assemble and send
       * a message to the desired users.
       */
      function sendMessage() {
        $scope.currentlyCreating = true;
        var data = {
          organization_id: $scope.org.id,
          content: $scope.formData.content,
          expires_at: moment($scope.state.currentDatepickerDate).endOf('day').format(),
          user_ids: $scope.selectedUserIds,
          message_type: $scope.state.messageType
        };

        OrganizationMessages.create(data)
          .then(function(obj) {
            flash.success = 'Your message has been sent!';
            $scope.currentlyCreating = false;
            $state.go('storeAnnouncements.show', {id: obj.id});
          });
      }

      /**
       * Decide whether a message should be sent and if so, call
       * the sendMessage() function. If not enough tokens are
       * available, a modal will be opened to buy more.
       */
      $scope.goToNextStep = function() {
        if ($scope.state.q.isSms() && $scope.selectedUserIds.length > $scope.currentCredits) {
            // Not enough tokens to proceed onwards
            flash.error = 'You do not have enough tokens to send ' + $scope.selectedUserIds.length + ' SMS messages.';
            $scope.activateBuyTokenModal();
        } else if ($scope.state.q.isSms() && $scope.formData.content.length > 140) {
          $confirm({
            title: 'Long Message',
            text: 'You\'re message is going to consume ' + $scope.creditsMultiplier + ' times the normal amount of credits because your message is greater than 140 characters. Send anyway?',
            ok: 'Send',
            cancel: 'Edit'
          }).then(function() {
              sendMessage();
            }, function() {
              // do nothing
            })
        } else if (!$scope.currentlyCreating) {
          sendMessage();
        }
      };

    });
